import 'swiper/css/swiper.css'
import Swiper from 'swiper'

if ($('#js-home-header').length) {
  const mainSliderSelector = '#js-slider-thumb',
    postSliderSelector = '#js-slider-post'

  const mainSliderOptions = {
    loop: true,
    slidesPerView: 1,
    centeredSlides: true
  }
  const mainSlider = new Swiper(mainSliderSelector, mainSliderOptions)

  const postSliderOptions = {
    effect: 'fade',
    slidesPerView: 1,
    loop: true,
    paginationClickable: true,
    autoplay: {
      delay: 4000,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
  }
  const postSlider = new Swiper(postSliderSelector, postSliderOptions)

  mainSlider.controller.control = postSlider
  postSlider.controller.control = mainSlider
}
